<template>
  <v-file-input
    truncate-length="30"
    show-size
    :label="itemAction.name"
    outlined
    dense
    @change="selectFile"
  />
</template>
<script>
export default {
  name: 'FileInputDinamicField',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    currentFile: null,
    message: ''
  }),
  watch: {
    setterModel (val) {
      if (val) {
        this.object = val
        this.objects.push(val)
      }
    }
  },
  methods: {
    selectFile (file) {
      this.onSuccess({ id: this.itemAction.nameid, data: file })
    }

  }
}
</script>

<style></style>
